// Opens a PDF and reads per-page dimensions up front so callers can size
// every page element before any canvas renders. Viewports are CropBox-based,
// matching smart_field_placements space.
export async function loadPdfDocument(source) {
  const pdfjs = await loadPdfjs()
  // A string is a URL; anything else passes through as a pdf.js source (e.g.
  // {data} for already-fetched bytes). v6 getDocument only reads an options
  // object, and rejects relative URLs — resolve Rails paths against the
  // page first.
  const options =
    typeof source === "string" ? { url: new URL(source, window.location.href) } : source
  const pdf = await pdfjs.getDocument(options).promise
  const pages = []
  for (let number = 1; number <= pdf.numPages; number++) {
    const page = await pdf.getPage(number)
    const viewport = page.getViewport({ scale: 1 })
    pages.push({ height: viewport.height, number, width: viewport.width })
  }
  return { pages, pdf }
}

// Lazy-load pdf.js so its ~1MB chunk is only fetched on pages that render
// PDFs, and wire its module worker (CSP already allows worker_src :self, :blob).
// The legacy build polyfills very new JS (e.g. Uint8Array#toHex) that the
// modern build assumes, keeping slightly older admin browsers working.
async function loadPdfjs() {
  const [pdfjs, worker] = await Promise.all([
    import("pdfjs-dist/legacy/build/pdf.mjs"),
    import("pdfjs-dist/legacy/build/pdf.worker.min.mjs?url"),
  ])
  pdfjs.GlobalWorkerOptions.workerSrc = worker.default
  return pdfjs
}
